import type { Rule } from "antd/lib/form";
import { isSteuerIdValid } from "validate-steuerid";

/**
 * An entered Steuer-ID must be 11 digits, not start with 0 and have a valid
 * check digit. An empty value passes here (use `required` for that), so
 * "required" and "invalid" do not both show.
 */
export const isEnteredSteuerIdValid = (value?: string): boolean =>
  !value || isSteuerIdValid(value);

type Translate = (key: string, options?: Record<string, unknown>) => unknown;

/**
 * antd rule with one message for every invalid Steuer-ID. `messageKey` lets a
 * module with its own i18n namespace (tax-registration) use its own key.
 */
export const getSteuerIdValidatorRule = (
  t: Translate,
  messageKey = "TaxNumbers:errors.steuerIdInvalid"
): Rule => ({
  validator: (_, value?: string) =>
    isEnteredSteuerIdValid(value)
      ? Promise.resolve()
      : Promise.reject(new Error(String(t(messageKey)))),
});

export const getRequiredSteuerIdRules = (t: Translate): Rule[] => [
  { required: true, message: String(t("TaxNumbers:errors.steuerIdRequired")) },
  getSteuerIdValidatorRule(t),
];
